import { render } from "./errors-layout.vue?vue&type=template&id=48f179bc"
import script from "./errors-layout.vue?vue&type=script&lang=js"
export * from "./errors-layout.vue?vue&type=script&lang=js"

import "./errors-layout.vue?vue&type=style&index=0&id=48f179bc&lang=scss"
script.render = render

export default script